import { useEffect } from 'react';
import { evalJavaScript } from 'js/utils/DOM.util';
import { tagTypeService } from 'js/services/tagType.service';
import { TAG_TYPE } from 'js/components/system/TagManager/constants';

export const CustomJs = ({ config }) => {
    const { code } = config;

    useEffect(() => {
        evalJavaScript({ code });
    }, [code]);

    return null;
};

tagTypeService.registerTagType({ [TAG_TYPE.customJs]: CustomJs });
